import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import Overline from "@/components/Overline";
import ClientLogo from "@/components/ClientLogo";
import ClientMarquee from "@/components/ClientMarquee";
import { activeClients } from "@/data/clients";
import { seo, buildQuoteUrl } from "@/config/site";

export default function Clients() {
  const clients = activeClients();
  return (
    <>
      <SEO
        title="Clients"
        description="A selection of businesses supplied by Rudraksh Corrugation Solutions."
        canonical={`${seo.siteUrl}/clients`}
      />
      <section className="border-b border-neutral-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <Overline>Trusted Relationships</Overline>
          <h1 className="font-heading mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-neutral-900">Clients</h1>
          <p className="mt-5 max-w-3xl text-neutral-600 leading-relaxed">
            A selection of businesses we have supplied packaging to.
          </p>
        </div>
      </section>

      <section className="py-10 bg-[#F5F5F5] border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ClientMarquee />
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {clients.map((c) => (
              <div key={c.name} className="bg-white border border-neutral-200 h-32 flex items-center justify-center p-6 rounded-sm">
                <ClientLogo client={c} className="w-full h-full" monochrome={false} />
              </div>
            ))}
          </div>
          <p className="mt-8 text-center text-sm text-neutral-500">Working across manufacturing, automotive, electronics, publishing and industrial sectors.</p>
          <div className="mt-6 text-center">
            <a href={buildQuoteUrl()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-[#A91D22] text-white px-6 py-3 text-sm font-medium hover:bg-[#8B181C] rounded-sm">
              Discuss Your Requirement
            </a>
          </div>
          <div className="mt-4 text-center">
            <Link to="/products" className="text-sm text-neutral-700 hover:text-[#A91D22]">Browse products →</Link>
          </div>
        </div>
      </section>
    </>
  );
}
